import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../App.css';
import '../Components/Layout/Navbar.css';
import '../assets/fontello-map/fontello-f0ab993c/css/fontello.css';
import './TrustPage.css';

import TrustHero from '../Components/Trust/TrustHero';
import DonationSection from '../Components/Trust/DonationSection';
import EventsSection from '../Components/Trust/EventsSection';
import CategoryCards from '../Components/Trust/CategoryCards';
import LocationModal from '../Components/Trust/LocationModal';

/**
 * TrustPage Component
 * Serves as the primary 'Homepage' for the Community Trust section of the application.
 * Manages the state for events, category filtering, and tutorial interactions.
 */
function TrustPage() {
  const location = useLocation();

  // Local state for UI toggles and data
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [events] = useState([]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);

  useEffect(() => {
    if (location.state?.category) {
      setSelectedCategory(location.state.category);
      setTimeout(() => {
        document.getElementById('bookings')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return;
    }

    if (location.hash === '#bookings' || location.hash === '#trust-events-section') {
      setTimeout(() => {
        document.getElementById('bookings')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location.pathname, location.hash, location.state]);

  const handleViewCategory = category => {
    setSelectedCategory(prev => (prev === category ? null : category));
    document.getElementById('bookings')?.scrollIntoView({ behavior: 'smooth' });
  };

  const openLocationModal = () => {
    setLocationModalOpen(true);
  };

  const handleCloseLocationModal = () => {
    setLocationModalOpen(false);
  };

  return (
    <div className="trust-page">
      <main className="home-content full-width">
        {/* Top Hero section specific to the Trust page */}
        <TrustHero onViewLocations={openLocationModal} />

        {/* Section displaying scheduled events */}
        <EventsSection id="trust-events-section" events={events} selectedCategory={selectedCategory} />

        {/* Cards filtering events by specific categories */}
        <CategoryCards
          events={events}
          selectedCategory={selectedCategory}
          onViewCategory={handleViewCategory}
        />

        {/* Component for handling user donations */}
        <DonationSection />

        {/* Modal popup for viewing the trust's locations */}
        <LocationModal
          isOpen={locationModalOpen}
          onClose={handleCloseLocationModal}
          initialCategory={selectedCategory || 'community'}
        />
      </main>
    </div>
  );
}

export default TrustPage;